var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iframe',{attrs:{"src":"https://speckle.xyz/embed?stream=71cc6e8d34&commit=a17d4b3da2&filter=%7B%7D&transparent=true&autoload=true","width":"100%","height":"100%","frameborder":"0"}})])
}]

export { render, staticRenderFns }